import { HttpClient, } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Customization } from '../video-library.model';
import { VideoLibraryService } from '../video-library.service';

@Injectable({
  providedIn: 'root',
})
export class CustomizeBrandingService {
  isLFODEnabledCount = true;
  isSe4LFODEnabledCount = true;
  isSe3LFODEnabledCount = true;
  isCustomLibraryEnabledCount = true;
  private _lastFacilityId: string;  
  private _customizeDataBs = new BehaviorSubject<Customization | any>(null);
  private _isUpdateEnabledStatus$: Subject<void>  = new Subject<void>();

  customizeDataSubscriber = this._customizeDataBs.asObservable();
  isUpdateEnabledStatus$ = this._isUpdateEnabledStatus$.asObservable();

  constructor(private _http: HttpClient, private _vdoLibraryService: VideoLibraryService) {}

  async getCustomize(facilityId: string)  {
    try {
      this._lastFacilityId = facilityId;
      const headers = await this._vdoLibraryService.getHeader();
      const data = await this._http.get(`${environment.apigeeCMSUrl}/customize?filters[facilityId][$eq]=${facilityId}&apikey=${environment.apiKey}&populate=*`, {headers}).toPromise();
      this._customizeDataBs.next(data);
    } catch (error) {
      console.error('API error');
    }
  }

  async saveCustomize(payload: any) {
    try {
      const headers = await this._vdoLibraryService.getHeader();
      await this._http.post(`${environment.apigeeCMSUrl}/customize?apikey=${environment.apiKey}`, payload, {headers}).toPromise();
      this.getCustomize(this._lastFacilityId);
    } catch (error) {
      console.error('API error');
      throw error;
    }
  }

  triggerEnableStatus(): void {
    this._isUpdateEnabledStatus$.next();
  }
}
